<template>
  <div class="container-jurado">    
    <div class="container container-fade">      
        <div class="row">
          <div class="col-12">
            <div class="border-bottom  mt-5 mb-5">
              <h2 class="text-center">{{ article.story.jurado.title }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4" v-for="(item, ix) in article.story.jurado.miembros" :key="`jurado_${ix}`">
            <div class="circulo">
              <img width="100%" :src="`${publicPath}${item.picture}`" />
            </div>
            <div class="linea">
              <h3 class="mt-3 mb-3">{{ item.name }}</h3>
            </div>
            <div class="mt-3">
              <h4>{{ item.subtitle }}</h4>
              <div v-html="item.bio"></div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12 col-md-12">
            <div class="text-center">
              <img width="100px" :src="`${publicPath}assets/images/estrellas.png`" />
            </div>
          </div>         

        </div>
      </div>
    </div>

</template>

<script>


export default {
  name: 'MainJurado',
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    article() {
      return require(`@/i18n/es.json`)
    }
  }
}

</script>
